import { render } from "./TheTemplateH.vue?vue&type=template&id=3b699d85&scoped=true&ts=true"
import script from "./TheTemplateH.vue?vue&type=script&lang=ts"
export * from "./TheTemplateH.vue?vue&type=script&lang=ts"

import "./TheTemplateH.vue?vue&type=style&index=0&id=3b699d85&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b699d85"]])

export default __exports__